import { createSelector } from 'reselect'

const getRecaptchaState = state => state.reCaptcha

export const getValidateRecaptchaData = createSelector([getRecaptchaState], validateRecaptcha =>
  validateRecaptcha ? validateRecaptcha.data : null
)

export const getValidateRecaptchaIsFetching = createSelector(
  [getRecaptchaState],
  validateRecaptcha => (validateRecaptcha ? validateRecaptcha.isFetching : false)
)

export const getValidateRecaptchaError = createSelector(
  [getRecaptchaState],
  validateRecaptcha => validateRecaptcha.error
)
